<template>
<div>
  <div class="container form-container">
      <div class="row pb-3">
          <div class="col-12 col-xl-4 mb-3">
              <div class="clinical-trials-content">
                  <h2 :class="post_title_h_style">{{ post_title }}</h2>
                  <div v-html="post_description"></div>
              </div>
          </div>
          <div class="col-12 col-xl-8">
            <clinical-form v-on:before-search="beforeSearch" v-on:search-results="onSearchResults"></clinical-form>
          </div>
      </div>
  </div>
  <div class="container-fluid clip-path-ellipse-concave-square" id="clinical-trials-results-wrap">
    <div class="container py-3">
      <div class="row vue-search-results">
          <clinical-results-heading :posts="posts"></clinical-results-heading>
      </div>
      <div class="row" id="clinical-trials-results">
          <clinical-results v-for="post in currentPosts" :key="post['title']" :post="post"></clinical-results>
          <div class="col-12" v-bind:class="{'d-none': $store.state.results_count || !initialized }">{{ no_results_message }}</div>
      </div>
    </div>
    <div class="container py-2" v-bind:class="{'d-none': has_more }">
      <div class="row justify-content-center">
        <button type="button" @click.prevent="showMoreCards()" class="btn btn-primary">Load More Results</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ClinicalForm from '../wf-clinical-form.vue'
import ApiCalls from "../../api/apiServices"
import ClinicalResultsHeading from '../headings/wf-clinical-results-heading.vue'
import ClinicalResults from '../results/wf-clinical-trials-results.vue'
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      post_title: window.clinical_trials_search ? window.clinical_trials_search.form_title : '',
      post_title_h_style: window.clinical_trials_search && window.clinical_trials_search.form_title_h_style ? window.clinical_trials_search.form_title_h_style : "h4",
      post_description: window.clinical_trials_search ? window.clinical_trials_search.form_description : '',
      posts: '',
      no_results_message: window.clinical_trials_search ? window.clinical_trials_search.no_results_message : 'No results found.',
      initialized: false
    }
  },
  computed: {
    getTrialsCount() {
      return this.$store.state.results_count
    },
    currentPosts() {
      return this.posts
    },
    has_more() {
      return this.$store.state.results_count <= this.$store.state.shown_count
    }
  },
  methods: {
    ...mapMutations(
      ['incrementCount', 'resetCount', 'showMore', 'resetTrialsShowCount']
    ),
    type() {
      return "ClinicalSearchTemplate"
    },
    resetTrialCount(){
      this.resetCount(this)
    },
    beforeSearch(evt) {
      this.resetCount(this)
      this.resetTrialsShowCount(this)
    },
    onSearchResults(data) {
      this.resetCount(this)
      for (var post in data) {
        this.incrementCount(this)
      }
      this.setPosts(data).then((status) => {
        if(status == 'true') {
          this.showCards()
        }
      })
      if (this.initialized) {
        document.querySelector('.vue-search-results').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      this.$set(this, 'initialized', true);
    },
    setPosts(data){
      return new Promise((resolve, reject) => {
        if(data !== null){
          this.$set(this, 'posts', data)
          resolve('true')
        } else {
          resolve('false')
        }
      })
    },
    showCards(){
      let cards = document.querySelectorAll('#clinical-trials-results .card-wrap')
      let count = 0
      if(cards != null && cards.length > 0){
        [...cards].forEach((card) => {
          if(count < this.$store.state.shown_count) {
            card.classList.remove('active')

            if(!card.classList.contains('active')) {
              card.classList.add('active')
              count++
            }
          }
        })
      }
    },
    showMoreCards(){
      this.showMore(this)
      this.showCards()
    },
  },
  components: {
    'clinical-results-heading' : ClinicalResultsHeading,
    'clinical-results' : ClinicalResults,
    'clinical-form': ClinicalForm
  },
  mounted() {
    this.resetTrialCount()
  },
}
</script>